import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';

// components
import {
  Button,
  FormGroup,  
  Input,  
  Modal,
  Row,
  Col,
} from "reactstrap";
import Select from 'react-select'
import moment from "moment";

// services
import { showMessage } from "../../services/message.js";
import { getSessionCookie} from "../../services/session.js";
import { api_GET, api_POST } from "services/api_service.js";

export default function ModalAdicionarOcorrencia({stateModalOcorrencia, ordemColeta, item, handleReturn, showLoading}) {
    const session = getSessionCookie(); 

    const { register, handleSubmit, errors, setError, setValue, getValues, clearErrors } = useForm({ mode: "onBlur" });

    const [stateModal, setstateModal] = React.useState(stateModalOcorrencia);

    // Ocorr~encia
    const [optionsOcorrencia, setoptionsOcorrencia] = React.useState([]);
    const [ocorrencia, setOcorrencia] = React.useState(null);
    const loadOptionsOcorrencia = () => {        
        if (ordemColeta == null)
            return;
        api_GET(`Justificativa/GetByOcorrencia/${ordemColeta.modalidadeColetaId}`).then(result => {            
            if (result.status !== 200) {
              showMessage("Aviso", result.message, 'error', null);
            }
            else{
                setoptionsOcorrencia(result.data);
            }
          });
    }

    useEffect(() => {         
        setanexo(null);
        setstateModal(stateModalOcorrencia);
        loadOptionsOcorrencia();
    }, [stateModalOcorrencia]);

    useEffect(() => {    
        if (item == null)
            return;

        showLoading(true);
        api_POST(`GeoCoding/GetEndereco`, {latitude: item.lat, longitude: item.lng}).then(result => {
            showLoading(false);
            if (result.status !== 200) {
                showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'warning', null);
            }
            else {
                try {
                    setValue("endereco", result?.data?.enderecoFormatado);
                }
                catch {
                    showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'warning', null);
                }
            }
        });
    }, [item]);

    const [anexo, setanexo] = React.useState(null);
    const handleAnexo = (event) => {        
        if (event.target.files.length) {                
            var reader = new FileReader();
            let _file = event.target.files[0];
            reader.readAsDataURL(_file); 
            reader.onloadend = function() {
                var base64data = reader.result;                                    
                setanexo({
                    base64: base64data.split(',')[1], 
                    name: uuidv4() + '.' + _file.name.split('.').pop().toLowerCase()
                });                
            }                
        }
    }

    const handleAddOcorrencia = () => {
        let data = getValues();
        if (data.descricaoOcorrencia == ""){
            setError("descricaoOcorrencia");
            return;
        }

        if (ocorrencia == null){
            setError("ocorrencia");
            return;
        }
        
        let _evidencias = [];
        if (anexo != null)
            _evidencias.push({
                arquivo: "", arquivoBase64: anexo.base64, dataHoraArquivo: moment().format("YYYY-MM-DD HH:mm:ss")
            });

        let json_post = {
            ordemColetaId: ordemColeta.ordemColetaId,
            tipoAcao: "Ocorrência",
            veiculoId: ordemColeta.veiculoId,
            usuarioOperadorColetaId: session.usuarioId,
            latitude: item.lat,
            longitude: item.lng,
            observacao: data.descricaoOcorrencia,
            justificativaId: ocorrencia != null ? ocorrencia.justificativaId : null,
            ordemColetaAcaoColetorEvidencia: _evidencias,
            registroManual: true
        }

        showLoading(true)
        api_POST('AvaliacaoColeta/AdicionarOcorrencia', json_post).then(result => {            
            showLoading(false);
            if (result.status !== 200) {
              showMessage("Aviso", result.message, 'error', null);
            }
            else{
                showMessage("Atenção", "Ocorrência incluída na Ordem de Serviço!", 'success' , function(){handleReturn(result.data)});
            }
          });
    }


    return (
        <>
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"                
            >     
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-default">
                    Nova Ocorrência
                    </h4>
                    <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"   
                    onClick={() => handleReturn()}                 
                    >
                    <span aria-hidden={true}>×</span>
                    </button>
                </div>           
                <div className="modal-body">                                           
                    <Row className="mt-2">
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Endereço
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="endereco"                                    
                                    type="text"                                    
                                    disabled="true"
                                    innerRef={register()}
                                />                                
                            </FormGroup>
                        </Col> 
                        <Col md="12" lg="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Ocorrência
                                </label>
                                <Select
                                    name="ocorrencia"
                                    options={optionsOcorrencia}
                                    getOptionLabel={({descricao}) => descricao}
                                    getOptionValue={({justificativaId}) => justificativaId} 
                                    onChange={(value) => {setOcorrencia(value)}}
                                    value={ocorrencia != null && optionsOcorrencia.find(obj => obj.justificativaId === ocorrencia.justificativaId)}
                                    placeholder="Selecione"                                    
                                />    
                                {errors.ocorrencia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}                            
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Descrição da Ocorrência
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    name="descricaoOcorrencia"
                                    placeholder="Descrição"
                                    type="text"  
                                    innerRef={register({ required: true})}
                                />                                
                                {errors.descricaoOcorrencia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>                         
                        <Col md="12">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                Importar Arquivo
                                </label>
                                <Input
                                    className="form-control-alternative"                                            
                                    defaultValue=""
                                    name="arquivo"
                                    placeholder="Anexar Arquivo"
                                    type="file"
                                    onChange={handleAnexo}
                                />                                        
                            </FormGroup>
                        </Col>              
                    </Row>                       
                </div>
                <div className="modal-footer">
                <Button color="secondary" type="button" onClick={() => handleReturn()}>
                    Cancelar
                </Button>                
                <Button color="info" type="button" onClick={() => handleAddOcorrencia()}>
                    Adicionar Ocorrência
                </Button>                                
                </div>
            </Modal>
        </>
    );  
}
